import { ProductType, ResultType, selectResultType } from "features/searchResultsFacets";
import { store$ } from "@redux/store";
import { distinctUntilChanged, map } from "rxjs";
import { routingSelectors, buildNewUrl } from "features/routing";
import fastdom from "fastdom";
import ResultTab from "./resultTab";
import UrlSubdirectoryTypes from "../../enums/urlSubdirectoryTypes";

const { urlComponentsSelector } = routingSelectors;

export default class BuildersTab extends ResultTab {
  constructor() {
    super();
    this.qaAttribute = 'filters-result-type-builders';
    this.subdirectory = UrlSubdirectoryTypes.Builders.toString();
    this.content = 'Builders';
    this.resultType = ResultType.Builders.toString();
    this.productType = ProductType.AllProducts.toString();

    const resultTypeChange$ = store$.pipe(
      map(selectResultType),
      map((resultType) => this.resultType === resultType),
      distinctUntilChanged(),
    );
    resultTypeChange$.subscribe(this.setIsActive.bind(this));

    const urlSegmentsChange$ = store$.pipe(
      map(urlComponentsSelector),
      distinctUntilChanged(),
    );

    urlSegmentsChange$.subscribe(this.updateUrlSegments.bind(this));
  }

  updateUrlSegments(componentsUrl) {
    const { urlCoordinatesQueryString, urlLocation } = componentsUrl;

    const urlConfiguration = {
      urlSubdirectory: this.subdirectory,
      urlLocation,
      urlQueryString: urlCoordinatesQueryString ?? '',
    }

    this.url = buildNewUrl(urlConfiguration);
    this.updateUrl(this.url);
    fastdom.mutate(() => {
      const tabElement = this.getNode();
      if (tabElement) {
        tabElement.href = this.url;
      }
    });
  }
}
